import firebase from "firebase"
import "firebase/firestore"

firebase.initializeApp({
	apiKey: "AIzaSyDuXkEPrA6sjEunZQddLAoqjFpOp2Vzq7o",
	authDomain: "ffstats-3e3ac.firebaseapp.com",
	databaseURL: "https://ffstats-3e3ac.firebaseio.com",
	projectId: "ffstats-3e3ac",
	storageBucket: "ffstats-3e3ac.appspot.com",
	messagingSenderId: "184485123187",
})

export const db = firebase.firestore()
export const auth = firebase.auth()
//export const currentUser = auth.currentUser
